import { notification, Upload } from "antd";
import Loading from "../Loading";
import axios from "../../utils/axios";
import { useMutation } from "react-query";
import { useState } from "react";
import { FilePdfTwoTone } from "@ant-design/icons";
import { useParams } from "react-router-dom";

const Step0 = ({ setDocData }) => {
  const { main, mainfilter, pop } = useParams();
  const [file, setFile] = useState(null);
  const [sizeError, setSizeError] = useState("");

  const { mutate, isLoading } = useMutation({
    mutationKey: ["create_doc"],
    mutationFn: async (fileToUpload) => {
      if (!fileToUpload) {
        notification.warning({ duration: 2, message: "Please upload the file!" });
        throw new Error("No file");
      }

      const bodyFormData = new FormData();
      bodyFormData.append("file", fileToUpload);

      const res = await axios.post("client/api/doc/create", bodyFormData, {
        formData: true,
        showErrorMessage: true,
      });
      return res.data;
    },
    onSuccess: (data, fileToUpload) => {
      setDocData((p) => ({
        ...p,
        docid: data.docid,
        txn_id: data.txnid,
        file: fileToUpload,
      }));
      window.location.hash = `#/${main}/${mainfilter}/${pop}/1`;
    },
    onError: () => {
      setFile(null);
    },
  });

  const handleCustomRequest = ({ file, onSuccess, onError }) => {
    setFile(file); // Show file name immediately

    mutate(file, {
      onSuccess: (responseData) => {
        onSuccess(responseData); // Marks AntD status as "done" (optional but clean)
      },
      onError: (err) => {
        onError(err); // Marks AntD status as "error"
      },
    });
  };

  return (
    <>
      <Loading loading={isLoading} />
      <div className="step0_container relafull flex_center">
        <div className="upload_section flex_center">
          {file ? (
            <>
              <FilePdfTwoTone style={{ fontSize: 90 }} />
              <div className="upload_section_title">{file.name}</div>
              {/* Optional: extra uploading text */}
              {isLoading && <div className="upload_section_body">Uploading...</div>}
            </>
          ) : (
            <>
              <img src="/file-add.svg" alt="add_file" />
              <div className="upload_section_title">Drop Document here</div>
              <div className="upload_section_body">or Click here</div>
              <div className="upload_section_body">{sizeError ? <span style={{ color: "#ff4d4f" }}>{sizeError}</span> : "Max file size 80MB"}</div>
              <div className="second_circle" />
            </>
          )}
          <Upload.Dragger
            accept="application/pdf"
            multiple={false}
            showUploadList={false}
            customRequest={handleCustomRequest}
            beforeUpload={(f) => {
              const MAX = 80 * 1024 * 1024; // 80 MB
              if (f.size > MAX) {
                notification.error({ duration: 3, message: "File is too large. Maximum size is 80MB." });
                setSizeError("File is too large. Maximum size is 80MB.");
                return false;
              }
              setSizeError("");
              return true;
            }}
            className="upload_dragger absfull"
          />
        </div>
      </div>
    </>
  );
};

export default Step0;
